import React, { useEffect } from 'react'
import { useRequests } from '../../../../redux/reducer/requests'
import { useExtraProfile } from '../../../../hooks/useExtraProfile'
import AppLoader from '../../../features/appLoader/AppLoader'
import classNames from 'classnames'
import { rating as ratingData, sept2026ChangesRatingData } from '../../../../constants/copyright'
import useRatingInfo from '../../../../hooks/components/pages/rating/useRatingInfo'
import RatingHeader from '../rating-header/RatingHeader'
import RatingInfo from '../rating-info/RatingInfo'
import RatingCountDown from '../rating-count-down/RatingCountDown'
import { RatingItems } from '../../../features/rating'
import { showChangesRatingSept2026Modal } from '../../../../utils/changesRatingSept2026'
import { useModalsDataActions } from '../../../../hooks/useModalsDataActions'
import useServiceData from '../../../../hooks/useServiceData'

const { className } = ratingData

const Rating = React.forwardRef(function (_, ref) {
  const {
    authData: { isWeb },
  } = useRequests()
  const { isRatingPending, ratingInfo } = useRatingInfo()
  const { addModal } = useModalsDataActions()
  const { get, save } = useServiceData()

  const isPending = useExtraProfile()
  const activeRange = 'week'

  useEffect(() => {
    showChangesRatingSept2026Modal({
      modalServiceDataKey: sept2026ChangesRatingData.rating.serviceDataKey,
      state: 'rating',
      getServiceData: get,
      saveServiceData: save,
      addModal,
    })
  }, [])

  return (
    <section
      ref={ref}
      className={classNames('rating', `rating_${activeRange}`, className, !isWeb && 'app')}
    >
      <div className={`rating__content`}>
        <RatingHeader />

        <RatingCountDown />

        <div className={'rating__list'}>
          <div className={'rating__blocks'}>
            <RatingItems
              ratingInfo={ratingInfo}
              isPending={isPending}
            />
            <RatingInfo
              range={activeRange}
              ratingInfo={ratingInfo}
            />
          </div>
        </div>
      </div>

      {(isPending || isRatingPending) && <AppLoader />}
    </section>
  )
})
Rating.displayName = 'Rating'
export default Rating
